import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 导入插件
import request from './serve/http.js'
import api from './serve/api'
import * as tools from './tools/index'
import modal from './tools/modal'
import img from './assets/img/logo.png'
// 模态框对象
Vue.prototype.$modal = modal
// 在原型上扩展,这样不用在每个页面都导入request
Vue.prototype.HTTP = request;
Vue.prototype.$api = api;
Vue.prototype.$Linkbann = 'https://www.zhongxipaimai.com/api';
Vue.prototype.$Link = 'https://www.zhongxipaimai.com/api';
Vue.prototype.$Infoimg = img;

Object.keys(tools).forEach(k => Vue.prototype[k]= tools[k])
// 图片上传组件
import ImageUpload from "@/components/public/uploadimg.vue"
Vue.component('ImageUpload', ImageUpload)

//公共跳转路由
Vue.prototype.topath = function(url,data,blank){
  if(blank){
    let routeUrl = router.resolve({
      path: url,
      query: data
    });
    window.open(routeUrl.href, '_blank');
  }else{
    router.push({
      path: url,
      query: data
    });
  }
}
Vue.config.productionTip = false
import './assets/elementComponents.js'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')